import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { InfoIcon } from 'src/ui/assets/icons/other/InfoIcon';
import { withConfig } from 'src/withConfig';

interface DividendBoxPropsType {
    variant: DefaultComponentVariantType | null;
}

const setDividendBox = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        border-color: ${theme.star.raceSummary.borderColor};
        border-style: solid;
        border-width: 0 0 1px 1px;
    `;
};


export const DividendBox = withConfig(theme => styled('div', { label: 'DividendBox' })<DividendBoxPropsType>`
    ${({ variant }): SerializedStyles=> setDividendBox(variant, theme)};
    align-items: center;
    background: ${theme.star.raceCard.results.bgColorSecondary};
    display: flex;
    font-size: ${theme.star.fontSize.small};
    justify-content: start;
    padding: 8px;
`);

export const InfoIconBox = withConfig(theme => styled(InfoIcon, { label: 'InfoIconBox' })`
    color: ${theme.star.raceCard.results.txtColorTertiary};
    margin-right: 8px;
    width: 16px;
`);

export const InfoElement = styled('i', { label: 'InfoElement' })`
    font-style: normal;
    position: relative;
    &:not(:last-of-type) {
        &::after {
            content: '|';
            margin: 0 8px;
        }
    }
`;
